import { useState, useRef, memo } from "react";
import Select from "react-select";
import Draggable from "react-draggable";
import { AiFillCloseCircle } from "react-icons/ai";
import { HiArrowRightCircle } from "react-icons/hi2";
import TooltipAd from "../TooltipAd/TooltipAd";
import { splitDimensionStr, truncateElipseText } from "../../Utils/Utils";

const DraggableCard = ({
  childValues,
  reasignPosValues,
  deleteChildDivs,
  afterPageMovedArrUpdate,
  pageNumbersArrays,
}) => {
  const [displayPageMove, setDisplayPageMove] = useState(false);
  const [pageMovedValue, setPageMovedValue] = useState({});
  const refDrags = useRef(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDrag = (e, data, elName) => {
    reasignPosValues({
      name: elName,
      x: data.x,
      y: data.y,
    });
  };

  // console.log('DraggableCard childValues :', childValues)

  const selectPageOptChange = (e, childAd) => {
    setPageMovedValue(e);
    setDisplayPageMove((prev) => !prev);
    setIsDropdownOpen(false);
    const updata_temp = { ...childAd, page: e?.value };
    afterPageMovedArrUpdate(updata_temp);
  };

  const activePageOpt = (e) => {
    e.preventDefault();
    setDisplayPageMove((prev) => !prev);
    setIsDropdownOpen((prev) => !prev);
  };

  const adUnderSize = (adSize = "5x3") => {
    const [widthStr, heightStr] = splitDimensionStr(adSize);
    const UNDER_SIZE = 5;
    const width = Number(widthStr);
    const height = Number(heightStr);
    const underWidth = width <= UNDER_SIZE;
    const underHeight = height <= UNDER_SIZE;
    const checkCondn = underWidth || underHeight;
    return checkCondn;
  };

  const contentList = (ads) => {
    console.log('ads :', ads)
    const AGENT_CUST_NAME_LENGTH_EXCEED = 20;
    const SHOW_AGENT_CUST_NAME_LENGTH_EXCEED = 5;
    return (
      <div>

        {/* <p>{"Id", ads?.cio_number }</p>
        <p>{"Size",ads?.size }</p>
        <p> {"Client",ads?.client_name} </p>
        <p>{ "As On Date",ads?.as_on_date } </p>
        <p>{ "File Name",ads?.file_name } </p>
        <p>{ "Colour",ads?.color } </p>
        <p>{"Slug Number",ads?.slug_number }</p>
        <p>{"Agent Name",ads?.agent_name }</p>
        <p>{"Caption",ads?.caption} </p>
        <p>{"Amt",ads?.amount_status }</p> */}

      {/*{ads?.cio_number && <p><strong>Id:</strong> {ads.cio_number}</p>}*/}
      {ads?.size && <p><strong>Size:</strong> {ads.size}</p>}
      {ads?.client_name && <p><strong>Client:</strong> {ads.client_name}</p>}
      {ads?.as_on_date && <p><strong>As On Date:</strong> {ads.as_on_date}</p>}
      {/*{ads?.file_name && <p><strong>File Name:</strong> {ads.file_name}</p>}*/}
      {ads?.color && <p><strong>Colour:</strong> {ads.color}</p>}
      {/*{ads?.slug_number && <p><strong>Slug Number:</strong> {ads.slug_number}</p>}*/}
      {/*{ads?.agent_name && <p><strong>Agent Name:</strong> {ads.agent_name}</p>}*/}
      {ads?.caption && <p><strong>Caption:</strong> {ads.caption}</p>}
      {/*{ads?.ads_color && <p><strong>Ad Color:</strong> {ads.ads_color}</p>}*/}
      {ads?.material_file_name && <p><strong>Material Name:</strong> {ads.material_file_name}</p>}
      {/*{ads?.amount_status && <p><strong>Amt:</strong> {ads.amount_status}</p>}*/}
      </div>
    );
  };

  const parentOffset = refDrags.current?.offsetParent?.getBoundingClientRect() || { left: 0, top: 0 };
const adjustedX = childValues.gridX - parentOffset.left;
const adjustedY = childValues.gridY - parentOffset.top;


  return (
    <Draggable
      bounds="parent"
      position={{
        x: Number(childValues?.gridX),
        y: Number(childValues?.gridY),
      }}
      onStart={(e) => {
        if (isDropdownOpen) {
          e.preventDefault();
          return false;
        }
      }}
      onStop={(e, data) => {
        if (isDropdownOpen) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        handleDrag(e, data, childValues.id);
      }}
      // onStop={(e, data) => handleDrag(e, data, childValues.id)}
      nodeRef={refDrags}
    >
      <div
        id={childValues.id}
        style={{
  position: "absolute",
  backgroundColor: "#cdebf9",
  border: "1px solid #78b7d3",
  width: childValues?.width + "px",
  height: childValues?.height + "px",
  cursor: "pointer",
  boxSizing: "border-box",
  overflow: "hidden",
          zIndex: 10,
}}
        className="draggableCard"
        ref={refDrags}
      >
        <div
            className="dragCard-innerContent"
            style={{
              "--print-ad-font-size":
                  childValues?.width < 250 || childValues?.height < 180
                      ? "11px"
                      : childValues?.width < 400 || childValues?.height < 300
                          ? "14px"
                          : "18px",
            }}
        >
          <span
            title="Change page"
            className="moveAdArrow"
            onClick={activePageOpt}
          >
            <HiArrowRightCircle size={22} color="black" />
          </span>
          {displayPageMove && (
            <span className="moverAdPageOpt">
             <Select
  options={pageNumbersArrays}
  value={pageMovedValue}
  onChange={(e) => selectPageOptChange(e, childValues)}
  onMenuOpen={() => setIsDropdownOpen(true)}
  onMenuClose={() => setIsDropdownOpen(false)}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
  container: (base) => ({
    ...base,
    width: "80px",
  }),

  control: (base) => ({
    ...base,
    width: "80px",
    minWidth: "80px",
  }),

  menu: (base) => ({
    ...base,
    width: "80px",
    minWidth: "80px",
    zIndex: 99999,
  }),

  menuList: (base) => ({
    ...base,
    width: "80px",
    maxHeight: "330px",
    padding: 0,
  }),

  option: (base, state) => ({
    ...base,
    width: "100%",
    boxSizing: "border-box",
    padding: "8px 10px",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#222",
    whiteSpace: "nowrap",
    backgroundColor: state.isFocused ? "#deebff" : "#fff",
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 99999,
  }),
}}
/>
            </span>
          )}

          {childValues?.material_image ? (
              <img
                  src={`data:image/jpeg;base64,${childValues.material_image}`}
                  alt={childValues?.material_file_name || "Advertisement"}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}

              />
          ) : (
              adUnderSize(childValues?.size) ? (
                  <TooltipAd renderComponent={contentList(childValues)}/>
              ) : (
                  contentList(childValues)
              )
          )}
        </div>
        <span
          title="remove"
          className="delChildDiv"
          onClick={(e) => deleteChildDivs(e, childValues)}
        >
          <AiFillCloseCircle size={20} color="black" />
        </span>
      </div>
    </Draggable>
  );
};

export default memo(DraggableCard);
